import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ScreenProvider } from "./context/ScreenContext";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./pages/Home";
import Services from "./pages/Services";
import MedicalDirectory from "./pages/MedicalDirectory";
import DoctorsDetails from "./pages/DoctorsDetails";
import Location from "./pages/Location";
import VisionMission from "./pages/VisionMission";
import FrequentlyQuestions from "./pages/FrequentlyQuestions";
import InsuranceCompanies from "./pages/InsuranceCompanies";
import ContactDoctors from "./pages/ContactDoctors";
import TermsOfUse from "./pages/TermsOfUse";
import SitePolicies from "./pages/SitePolicies";
import ComprehensivePrivacy from "./pages/ComprehensivePrivacy";
import ScrollToTop from "./pages/ScrollToTop";
import Footer from "./components/Footer";
import ProjectCreation from "./pages/ProjectCreation";

const App = () => {
  return (
    <ScreenProvider>
      <Navbar />
      <ScrollToTop />
      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicios" element={<Services />} />
          <Route path="/directorioMedico" element={<MedicalDirectory />} />
          <Route path="/como-llegar" element={<Location />} />
          <Route path="/conoceElProyecto" element={<ProjectCreation />} />
          <Route path="/detalles-doctor" element={<DoctorsDetails />} />
          <Route path="/mision-y-vision" element={<VisionMission />} />
          <Route
            path="/preguntas-frecuentes"
            element={<FrequentlyQuestions />}
          />
          <Route path="/aseguradoras" element={<InsuranceCompanies />} />
          <Route path="/contacto-medicos" element={<ContactDoctors />} />
          <Route path="/terminos-de-uso" element={<TermsOfUse />} />
          <Route path="/politicas-del-sitio" element={<SitePolicies />} />
          <Route
            path="/aviso-de-privacidad"
            element={<ComprehensivePrivacy />}
          />
        </Routes>
        <Footer />
      </Suspense>
    </ScreenProvider>
  );
};

export default App;
